<template>
  <div>
    <div id="items3">
        <hm-card
          v-for="element in myArray"
          :key="element.id"
          :select="element.id == selectCardId ? true : false"
          @click.native="selectCard(element.id)"
        ><a-button>{{element.name}}</a-button></hm-card>
    </div>
    <!-- <draggable v-model="myArray" group="a">
      <hm-card  v-for="element in myArray" :key="element.id"><a-button>{{element.name}}</a-button></hm-card>
    </draggable> -->
		<!-- <hm-card v-for="element in myArray" :key="element.id" class="item">
			<a-button>{{ element.name }}</a-button>
		</hm-card> -->
		<!-- <hm-card><a-button>点击按钮</a-button></hm-card>
		<hm-card><a-button>点击按钮</a-button></hm-card>
		<hm-card><a-button>点击按钮</a-button></hm-card> -->
  </div>
</template>

<script>
import HmCard from "@/components/HmCard.vue";
import draggable from "vuedraggable";

export default {
  components: {
    HmCard,
    draggable,
  },
  data() {
    return {
      enabled: true,
      selectCardId: null,
      myArray: [
        { name: "John", id: 0 },
        { name: "Joao", id: 1 },
        { name: "Jean", id: 2 }
      ],
      dragging: false
    };
  },
  methods:{
    selectCard(id){
      if(id == this.selectCardId){
        this.selectCardId = null
      }else{
        this.selectCardId = id
      }
    },
  }
};
</script>
